export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/Login.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () =>
      import(/* webpackChunkName: "auth" */ '@/views/Register.vue'),
  },
  {
    path: '/register/complete',
    name: 'RegisterComplete',
    component: () =>
      import(/* webpackChunkName: "auth" */ '@/views/RegisterComplete.vue'),
  },
  {
    path: '/register/workspace',
    name: 'Workspace',
    component: () =>
      import(/* webpackChunkName: "auth" */ '@/views/Workspace.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: () =>
      import(/* webpackChunkName: "auth" */ '@/views/Forgot.vue'),
  },
  {
    path: '/',
    name: 'Home',
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'request-load',
        name: 'Request load',
        component: () =>
          import(
            /* webpackChunkName: "marketplace" */ '@/views/RequestLoad.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'find-empty-container',
        name: '/Find empty container',
        component: () =>
          import(
            /* webpackChunkName: "marketplace" */ '@/views/FindEmptyContainer.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'post-empty-container',
        name: 'Post Empty Container',
        component: () =>
          import(
            /* webpackChunkName: "marketplace" */ '@/views/PostEmptyContainer.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'drayrates',
        name: 'DrayRates',
        component: () =>
          import(/* webpackChunkName: "marketplace" */ '@/views/DrayRates.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'integrations',
        name: 'Integrations',
        component: () =>
          import(
            /* webpackChunkName: "marketplace" */ '@/views/Integrations.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () =>
          import(
            /* webpackChunkName: "notification" */ '@/views/Notification.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () =>
          import(/* webpackChunkName: "setting" */ '@/views/Setting.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () =>
          import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/history',
        name: 'Turns History',
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/TurnHistory.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'chat',
        name: 'Chat',
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Chat.vue'),
        meta: { requiresAuth: true },
      },
    ],
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '@/views/Home.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/help-center',
    name: 'Documentation',
    component: () =>
      import(
        /* webpackChunkName: "documentation" */ '@/views/Documentation.vue'
      ),
    meta: { requiresAuth: true },
  },
  {
    path: '/docs/legal/terms',
    name: 'Terms',
    component: () =>
      import(/* webpackChunkName: "documentation" */ '@/views/Terms.vue'),
  },
  {
    path: '/docs/legal/privacy',
    name: 'Privacy',
    component: () =>
      import(/* webpackChunkName: "documentation" */ '@/views/Privacy.vue'),
  },

  {
    path: '/payments/connect',
    name: 'Connect Payment',
    component: () =>
      import(
        /* webpackChunkName: "connectPayment" */ '@/views/ConnectPayment.vue'
      ),
    meta: { requiresAuth: true },
  },
  {
    path: '/payouts/connect',
    name: 'Connect Payout',
    component: () =>
      import(
        /* webpackChunkName: "connectPayment" */ '@/views/ConnectPayout.vue'
      ),
    meta: { requiresAuth: true },
  },
  {
    path: '/verify',
    name: 'Verify',
    component: () =>
      import(/* webpackChunkName: "verify" */ '@/views/Verify.vue'),
  },
  {
    path: '/auth/verify',
    name: 'VerifyAuth',
    component: () =>
      import(/* webpackChunkName: "verify" */ '@/views/VerifyAuth.vue'),
  },
  {
    path: '/auth/verify/email',
    name: 'VerifyEmail',
    component: () =>
      import(/* webpackChunkName: "verify" */ '@/views/VerifyEmail.vue'),
    meta: { guestUser: true },
  },
  {
    path: '/reservations/:token',
    name: 'GuestReservation',
    component: () =>
      import(
        /* webpackChunkName: "GuestReservation" */ '@/views/GuestReservation.vue'
      ),
    meta: { guestUser: true },
  },
  {
    path: '/status',
    name: 'GuestStatusMessage',
    component: () =>
      import(
        /* webpackChunkName: "Guest Status Message" */ '@/views/GuestStatusMessage.vue'
      ),
    meta: { guestUser: true },
  },
  {
    path: '/agent-verify',
    name: 'VerifyAgent',
    component: () =>
      import(/* webpackChunkName: "verify" */ '@/views/VerifyAgent.vue'),
    meta: { guestUser: true },
  },
  {
    path: '/bookings',
    name: 'Bookings',
    component: () =>
      import(/* webpackChunkName: "Booking" */ '@/views/Bookings.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/payments/checkout',
    name: 'Checkout Plan',
    component: () =>
      import(
        /* webpackChunkName: "Checkout Plan" */ '@/views/CheckoutPlan.vue'
      ),
    meta: { requiresAuth: true },
  },
  {
    path: '/guest',
    name: 'Guest',
    component: () =>
      import(/* webpackChunkName: "Guest" */ '@/views/Guest.vue'),
  },
];
